export const RETRIEVE_PROCEDURES = 'procedures/retrieve';
export const RETRIEVE_PROCEDURE = 'procedure/retrieve';
